import { LIST_TYPE } from "@/shared/types/atoms.types";
import React, { useMemo } from "react";

interface ListSectionProps {
  listIndex: string;
  title?: string;
  description?: any;
  listType?: LIST_TYPE;
}

const ListSection: React.FC<ListSectionProps> = ({
  listIndex,
  title,
  description,
  listType,
}) => {
  const listStyle = useMemo(() => {
    if (listType === LIST_TYPE.LIST1) {
      return "ml-0";
    }
    if (listType === LIST_TYPE.LIST2) {
      return "ml-4 md:ml-6";
    }
    if (listType === LIST_TYPE.LIST3) {
      return "ml-4 md:ml-16";
    }
    if (listType === LIST_TYPE.LIST4) {
      return "ml-6 md:ml-28";
    }
    return "ml-2 md:ml-6";
  }, [listType]);
  return (
    <div className={`flex items-start ${listStyle} mb-3`}>
      <span
        className={`text-base ${
          listType !== LIST_TYPE.LIST3 && listType !== LIST_TYPE.LIST4
            ? "font-bold"
            : ""
        } mr-2 md:mr-5`}
      >
        {listIndex}
      </span>
      <div className="inline w-full">
        {title && (
          <h2 className="mr-3 inline-block text-base font-bold">{title}</h2>
        )}
        {description && description}
      </div>
    </div>
  );
};

ListSection.displayName = "ListSection";

export default ListSection;
